import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import List from './routes/List';

const Offers = ({match}) => (
	<div>
		<Switch>
			<Redirect exact from={`${match.path}/`} to={`${match.path}/list`}/>
			<Route path={`${match.path}/list`} component={ List } />
		</Switch>
	</div>
);

export default Offers;


// WEBPACK FOOTER //
// ./app/used/offers/index.js